<template>
  <div class="mask" @click.self="clickClose" @touchmove.self.prevent>
    <div class="content">
      <div class="content-title">购票提示</div>
      <div class="content-message">
        <p v-for="(item, index) in noticeList" :key="index">{{ item.em_message }}</p>
      </div>
      <div class="content-control">
        <div class="close">
          <button @click="clickClose">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "noticePopup",
  props: ['noticeList'],
  methods: {
    clickClose(){
      this.$emit('clickClose')
    },
  }
};
</script>

<style scoped lang='less'>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.42);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content{
  background: #fff;
  margin: 0 1.066667rem;
  width: 100%;
  border-radius: .4rem;
  min-height: 50vh;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  .content-title{
    text-align: center;
    font-size: 0.48rem;
    color: #333333;
    font-weight: bold;
    padding: .4rem 0;
    flex-shrink: 0;
  }
  .content-message{
    flex: 1;
    overflow-y: scroll;
    padding: 0 .666667rem;
    p{
      font-size: 0.32rem;
      color: #222328;
      line-height: 0.506666rem;
    }
  }

  .content-control{
    flex-shrink: 0;
    padding: 0.2rem 0 .4rem;
    .already-read{
      padding:0 0.4rem;
      display: flex;
      .read-box{
        padding: 0.2rem 0;
        display: flex;
        align-items: center;
      }
      img{
        width: 0.5rem;
      }
      span{
        font-size: 0.32rem;
        padding-left: .133333rem;
      }
    }

    .close{
      padding: 0 0.4rem;
      button{
        background: #3B6D9C;
        display: block;
        width: 100%;
        border-radius: .666667rem;
        line-height: 1.2rem;
        color: #fff;
        font-size: 0.5rem;
      }
    }
  }
}
</style>
